export default __webpack_public_path__ + "static/media/vg-footer.2b107fc1.png";